import { useState } from 'react';
import CardLayout from '../../../components/Layout/CardLayout';
import ReactDataTable from '../../../components/ReactDataTable/ReactDataTable';
import useFetch from '../../../hooks/useFetch';
import request from '../../../request/request';
import ModalLayout from '../../../components/Layout/ModalLayout';
import EditButton from '../../../components/Button/EditButton';
import DeleteButton from '../../../components/Button/DeleteButton';
import DeleteModal from '../../../components/Modal/DeleteModal';
import PopupformsForm from '../../../components/Forms/Websites/Popupforms/PopupformsForm';

const PopupForms = () => {
    const [modalOpen, setModalOpen] = useState('');
    const [selectedItem, setSelectedItem] = useState('');

    const { result, isLoading, setRefresh } = useFetch(() => request.getAll('popupform'));

    const columns = [
        {
            name: 'Name',
            center: true,
            selector: (row) => row?.name,
        },
        {
            name: 'Phone',
            center: true,
            selector: (row) => row?.phone,
        },
        {
            name: 'Email',
            center: true,
            selector: (row) => row?.email,
        },
        {
            name: 'Tour Type',
            wrap: true,
            center: true,
            selector: (row) => row?.tourtype,
        },
        {
            name: 'Destination',
            wrap: true,
            center: true,
            selector: (row) => row?.destination,
        },
        {
            name: 'Travel Category',
            wrap: true,
            center: true,
            selector: (row) => row?.travelcategory,
        },
        {
            name: 'Selected Month',
            wrap: true,
            center: true,
            selector: (row) => row?.selectedMonth,
        },
        {
            name: 'Duration',
            wrap: true,
            center: true,
            selector: (row) => row?.duration,
        },
        {
            name: 'Adults',
            wrap: true,
            center: true,
            selector: (row) => row?.adults,
        },
        {
            name: 'Children',
            wrap: true,
            center: true,
            selector: (row) => row?.children,
        },
        {
            name: 'WhatsApp Communication',
            wrap: true,
            center: true,
            selector: (row) => (row?.whatsappComunication ? 'Yes' : 'No'),
        },
        {
            name: 'Booking Date',
            wrap: true,
            center: true,
            selector: (row) => row?.bookingDate,
        },
        {
            name: 'Budget',
            wrap: true,
            center: true,
            selector: (row) => row?.budget,
        },
        {
            name: 'User Location',
            wrap: true,
            center: true,
            selector: (row) => row?.userlocation,
        },
        {
            name: 'Status',
            center: true,
            selector: (row) => (row?.status === 1 ? 'Active' : 'Inactive'),
        },
        {
            name: 'Active',
            center: true,
            cell: (row) => (
                <div>
                    <EditButton
                        onClick={() => {
                            setModalOpen('update');
                            setSelectedItem(row);
                        }}
                    />
                    <DeleteButton
                        onClick={() => {
                            setModalOpen('delete');
                            setSelectedItem(row);
                        }}
                    />
                </div>
            ),
        },
    ];

    // const columns = [
    //     {
    //         name: 'Name',
    //         center: 'true',
    //         selector: (row) => row?.name,
    //     },
    //     {
    //         name: 'btn_name',
    //         wrap: true,
    //         center: 'true',
    //         selector: (row) => row?.btn_name,
    //     },
    //     {
    //         name: 'btn_link',
    //         wrap: true,
    //         center: 'true',
    //         selector: (row) => row?.btn_link,
    //     },
    //     {
    //         name: 'Status',
    //         center: 'true',
    //         selector: (row) => (row?.status === 1 ? 'Active' : 'InActive'),
    //     },
    //     {
    //         name: 'Active',
    //         center: 'true',
    //         cell: (row) => (
    //             <div>
    //                 <EditButton
    //                     onClick={() => {
    //                         setModalOpen('update');
    //                         setSelectedItem(row);
    //                     }}
    //                 />
    //                 <DeleteButton
    //                     onClick={() => {
    //                         setModalOpen('delete');
    //                         setSelectedItem(row);
    //                     }}
    //                 />
    //             </div>
    //         ),
    //     },
    // ];

    // create new function

    const createNewServiceHandler = (formValue) => {
        // const formData = formDataConverter(formValue);

        request.create('popupform', formValue, () => {
            setModalOpen('');
            setRefresh((prev) => !prev);
        });
    };

    // update

    const updateServiceHandler = (formValue) => {
        // const formData = formDataConverter(formValue);

        request.updateOne('popupform', selectedItem?.id, formValue, () => {
            setModalOpen('');
            setRefresh((prev) => !prev);
        });
    };

    // delete

    const deleteServiceHandler = () =>
        request.delete('popupform', selectedItem?.id, () => {
            setModalOpen('');
            setRefresh((prev) => !prev);
        });

    return (
        <CardLayout
            title='Popup Forms List'
            buttonTitle='Add New'
            addButtonHandler={() => setModalOpen('create')}
        >
            <ReactDataTable data={result} columns={columns} pending={isLoading} />
            {/*= ============== create ===================== */}

            {modalOpen === 'create' && (
                <ModalLayout
                    isOpen={modalOpen === 'create'}
                    onClose={() => setModalOpen('')}
                    title='Create New Form'
                    size='lg'
                >
                    <PopupformsForm apiHandler={createNewServiceHandler} />
                </ModalLayout>
            )}

            {/* ======================= update ========================== */}

            {modalOpen === 'update' && (
                <ModalLayout
                    isOpen={modalOpen === 'update'}
                    onClose={() => setModalOpen('')}
                    title='Update Form'
                    size='lg'
                >
                    <PopupformsForm apiHandler={updateServiceHandler} editData={selectedItem} />
                </ModalLayout>
            )}

            {/* ======================= delete ========================== */}

            {modalOpen === 'delete' && (
                <DeleteModal
                    isOpen={modalOpen === 'delete'}
                    onClose={() => setModalOpen('')}
                    handleDelete={deleteServiceHandler}
                />
            )}
        </CardLayout>
    );
};

export default PopupForms;
